import Cookies from 'js-cookie';
import { StateCreator } from 'zustand';
import * as cartSvc from '@/services/cart.service';
import { ICart } from '../types/ICart';
import INITIAL_STATE from '../initialState';

function calcTotalItems(items: any[]) {
  return items.reduce((acc, { quantity, diamond }) => acc + (quantity || diamond.quantity), 0);
}

const createCartSlice: StateCreator<ICart> = (set, get) => ({
  cart: INITIAL_STATE.cart,
  async deleteCartItem(cartId: number) {
    try {
      set(state => {
        const items = state.cart.items.filter(i => i.id !== cartId);
        const totalItems = calcTotalItems(items);
        Cookies.set('cartCount', totalItems);
        return { cart: { ...state.cart, items, totalItems } };
      });
      await cartSvc.deleteCartItem(cartId);
      await get().getCartItems();
    } catch (e) {
      /* empty */
    }
  },
  async deleteGiftNote() {
    try {
      set(state => ({ cart: { ...state.cart, gift_note: [] } }));
      await cartSvc.deleteGiftNote();
    } catch (e) {
      /* empty */
    }
  },
  async getCartItems() {
    try {
      const { data } = await cartSvc.getCartItems();
      const totalItems = calcTotalItems(data.items);
      set(() => ({ cart: { ...data, totalItems } }));
    } catch (e) {
      /* empty */
    }
  },
});

export default createCartSlice;
